import { Link } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { EXPLORE_GROUPS, KIND_LABEL } from "../explore";

const PLATFORM_LINKS = [
  { to: "/map", key: "nav.map" },
  { to: "/knowledge", key: "nav.search" },
  { to: "/provenance", key: "nav.provenance" },
  { to: "/stories", key: "nav.stories" },
  { to: "/gallery", key: "nav.gallery" },
  { to: "/culinary", key: "nav.culinary" },
];

export default function Footer() {
  const { t, lang } = useApp();

  return (
    <footer className="lux-footer" data-testid="main-footer">
      <div className="footer-inner footer-inner-wide">
        <div className="footer-brand">
          <p className="footer-logo">
            واحة التمور <span>Dates Oasis</span>
          </p>
          <p className="footer-tagline">{t("footer.tagline")}</p>
          <p className="footer-domain">datesoasis.com</p>
        </div>
        <div className="footer-col">
          <p className="footer-col-title">{t("footer.platform")}</p>
          {PLATFORM_LINKS.map((l) => (
            <Link key={l.to} to={l.to} className="footer-link" data-testid={`footer-link-${l.to.slice(1)}`}>
              {t(l.key)}
            </Link>
          ))}
        </div>
        {EXPLORE_GROUPS.map((g) => (
          <div key={g.id} className="footer-col">
            <Link to={g.to} className="footer-col-title footer-col-link" data-testid={`footer-group-${g.id}`}>
              {g.label[lang]}
            </Link>
            {g.items.map((it) => (
              <Link key={it.slug} to={it.to} className="footer-link" data-testid={`footer-link-${it.slug}`}>
                {it.label[lang]}
              </Link>
            ))}
          </div>
        ))}
      </div>
      <div className="footer-base">
        <span>{t("footer.rights")}</span>
        <span className="footer-base-links">
          <Link to="/contact" className="footer-base-link" data-testid="footer-link-contact">{t("contact.title")}</Link>
          <Link to="/terms" className="footer-base-link" data-testid="footer-link-terms">{t("legal.terms.title")}</Link>
          <Link to="/privacy" className="footer-base-link" data-testid="footer-link-privacy">{t("legal.privacy.title")}</Link>
          <Link to="/dmca" className="footer-base-link" data-testid="footer-link-dmca">{t("legal.dmca.title")}</Link>
          <a href="/sitemap.xml" className="footer-base-link" data-testid="footer-sitemap-link">Sitemap</a>
        </span>
      </div>
    </footer>
  );
}
